export class Operator {

  constructor(
    public id: string,
    public displayLabel?: string,
    public description?: string,
    public status?: string
  ) {
  }

  clone(): Operator {
    return new Operator(this.id, this.displayLabel, this.description, this.status);
  }

}
